<template>
  <div class="frame">
    <h3>{{$t('Webportal.CX.Margin.MarginHelpTitle')}}</h3>
    <template v-if="year && year <= 2024">
      <p>{{$t('Webportal.CX.Margin.MarginHelpText1')}}</p>
    </template>
    <template v-else>
      <p>{{$t('Webportal.CX.Margin.MarginHelpText1_2')}}</p>
    </template>

    <table class="table table-bordered">
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="true" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange" /></td>
        <td>{{ $t('Webportal.CX.Margin.Accomplished') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="false" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange"/></td>
        <td>{{ $t('Webportal.CX.Margin.Failed') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="null" :HealingStatus="''" :InHealingPeriod="false" :ColorRange="colorRange" /></td>
        <td>{{ $t('Webportal.CX.Margin.NoData') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :InHealingPeriod="true" :IsCurrentWave="true" :IsHealingDeactivated="false" :Accomplished="false" :HealingStatus="''" :ColorRange="colorRange" :AvailableHealings="1"/></td>
        <td>{{ $t('Webportal.CX.Margin.HealingPossible') }}</td>
      </tr>
      <tr>
        <td><MarginKpiStatusIndicator :Accomplished="false" :HealingStatus="'in_progress'" :InHealingPeriod="false" :IsCurrentWave="true" :ColorRange="colorRange"/></td>
        <td>{{ $t('Webportal.CX.Margin.HealingInProgress') }}</td>
      </tr>
    </table>

    <p>{{$t('Webportal.CX.Margin.MarginHelpText2')}}</p>
    <p>{{$t('Webportal.CX.Margin.MarginHelpText3')}}</p>
    <template v-if="year && year <= 2024">
      <p>{{$t('Webportal.CX.Margin.MarginHelpText4')}}</p>      
    </template>
    <template v-else>
      <p>{{$t('Webportal.CX.Margin.MarginHelpText4_2')}}</p>      
    </template>

    <h5>{{ $t('Webportal.CX.Margin.FAQResultsReleaseHeadline') }}</h5>
    <ul>
      <template v-if="year && year <= 2024">
        <li>{{ $t('Webportal.CX.Margin.Q1ResultsRelease') }}</li>
        <li>{{ $t('Webportal.CX.Margin.Q2ResultsRelease') }}</li>
        <li>{{ $t('Webportal.CX.Margin.Q3ResultsRelease') }}</li>
        <li>{{ $t('Webportal.CX.Margin.Q4ResultsRelease') }}</li>        
      </template>
      <template v-else>
        <li>{{ $t('Webportal.CX.Margin.H1ResultsRelease') }}</li>
        <li>{{ $t('Webportal.CX.Margin.H2ResultsRelease') }}</li>        
      </template>
    </ul>
  </div>
</template>

<script>
import MarginKpiStatusIndicator from "@/components/CX/MarginKpiStatusIndicator.vue"

export default {
  components: {
    MarginKpiStatusIndicator
  },

  props: {
    colorRange: Array,
    year: Number
  }
}
</script>

<style scoped>
.frame {
  margin: 1rem;
}
</style>